import React, { Component, createRef } from "react";
import {
  POST,
  loading,
  tokens,
  locale,
  alert,
  float,
  Modal,
  required,
} from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import THUMBNAIL from "../assets/images/thumbnail.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slideIndex: 0,

      data_product: [],

      photo_index: [],

      product: [],
      full_name: "",
      email: "",
      phone: "",
      company: "",
      title: "",
      message: "",

      name_contact_1: "",
      address_contact_1: "",
      phone_contact_1: "",
      fax_contact_1: "",
      email_contact_1: "",
      website_contact_1: "",

      photo_section3_index: [],

      title_section2_index: "",
      message_section2_index: "",

      title1_section2_index: "",
      message1_section2_index: "",
      title2_section2_index: "",
      message2_section2_index: "",
      title3_section2_index: "",
      message3_section2_index: "",

      title_section3_index: "",
      message_section3_index: "",
      photo_section4_index: [],
      title_section5_index: "",
      message_section5_index: "",
      photo_section5_index: [],
      howto_section6_index: [],
      customer_section7_index: [],
    };
  }
  componentDidMount = async () => {
    this.timer = setInterval(this.nextSlide, 5000);

    loading(false);
    this.Get();
  };
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  nextSlide = () => {
    const { photo_index } = this.state;
    this.setState((prev) => ({
      slideIndex:
        prev.slideIndex === photo_index?.length - 1 ? 0 : prev.slideIndex + 1,
    }));
  };

  prevSlide = () => {
    const { photo_index } = this.state;
    this.setState((prev) => ({
      slideIndex:
        prev.slideIndex === 0 ? photo_index.length - 1 : prev.slideIndex - 1,
    }));
  };

  goToSlide = (index) => {
    this.setState({ slideIndex: index });
  };
  Get = async () => {
    loading(true);
    let result = null;
    let response = await fetch(process.env.REACT_APP_API_URL + "/updated.json");
    let update = await response.json();
    if (
      !tokens ||
      (tokens && tokens?.updated?.last_update !== update.last_update)
    ) {
      let response = await fetch(process.env.REACT_APP_API_URL + "/.json");
      result = await response.json();
      localStorage.setItem("scp-acc-tk", JSON.stringify(result));
    } else {
      result = tokens;
    }
    this.setState({
      photo_index: result?.setting?.photo_index,

      fax_contact:
        result?.setting[`${locale || "th"}_fax_contact`] ||
        result?.setting?.th_fax_contact,
      phone_contact:
        result?.setting[`${locale || "th"}_phone_contact`] ||
        result?.setting?.th_phone_contact,
      email_contact:
        result?.setting[`${locale || "th"}_email_contact`] ||
        result?.setting?.th_email_contact,

      data_product: (result?.product ? Object.values(result?.product) : [])
        ?.sort(() => Math.random() - 0.5)
        ?.slice(0, 6),

      name_contact_1:
        result?.setting[`${locale}_name_contact_1`] ||
        result?.setting?.th_name_contact_1,
      address_contact_1:
        result?.setting[`${locale}_address_contact_1`] ||
        result?.setting?.th_address_contact_1,
      phone_contact_1:
        result?.setting[`${locale}_phone_contact_1`] ||
        result?.setting?.th_phone_contact_1,
      fax_contact_1:
        result?.setting[`${locale}_fax_contact_1`] ||
        result?.setting?.th_fax_contact_1,
      email_contact_1:
        result?.setting[`${locale}_email_contact_1`] ||
        result?.setting?.th_email_contact_1,
      website_contact_1:
        result?.setting[`${locale}_website_contact_1`] ||
        result?.setting?.th_website_contact_1,

      title_section2_index:
        result?.setting[`${locale}_title_section2_index`] ||
        result?.setting?.th_title_section2_index,
      message_section2_index:
        result?.setting[`${locale}_message_section2_index`] ||
        result?.setting?.th_message_section2_index,

      title1_section2_index:
        result?.setting[`${locale}_title1_section2_index`] ||
        result?.setting?.th_title1_section2_index,
      message1_section2_index:
        result?.setting[`${locale}_message1_section2_index`] ||
        result?.setting?.th_message1_section2_index,
      title2_section2_index:
        result?.setting[`${locale}_title2_section2_index`] ||
        result?.setting?.th_title2_section2_index,
      message2_section2_index:
        result?.setting[`${locale}_message2_section2_index`] ||
        result?.setting?.th_message2_section2_index,
      title3_section2_index:
        result?.setting[`${locale}_title3_section2_index`] ||
        result?.setting?.th_title3_section2_index,
      message3_section2_index:
        result?.setting[`${locale}_message3_section2_index`] ||
        result?.setting?.th_message3_section2_index,

      title_section3_index:
        result?.setting[`${locale}_title_section3_index`] ||
        result?.setting?.th_title_section3_index,
      message_section3_index:
        result?.setting[`${locale}_message_section3_index`] ||
        result?.setting?.th_message_section3_index,
      photo_section4_index: result?.setting?.photo_section4_index,
      title_section5_index:
        result?.setting[`${locale}_title_section5_index`] ||
        result?.setting?.th_title_section5_index,
      message_section5_index:
        result?.setting[`${locale}_message_section5_index`] ||
        result?.setting?.th_message_section5_index,
      photo_section5_index: result?.setting?.photo_section5_index,
      howto_section6_index: result?.setting?.howto_section6_index,
      customer_section7_index: result?.setting?.customer_section7_index,
      photo_section3_index: result?.setting?.photo_section3_index,
    });
    loading(false);
  };
  Submit = async () => {
    const { product, full_name, email, phone, company, title, message } =
      this.state;
    if (!full_name) {
      alert("", "warning", "แจ้งเตือน", "กรุณาชื่อ-นามสกุล");
      return;
    }
    if (!phone) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทรศัพท์");
      return;
    }
    if (!email) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกอีเมล");
      return;
    }
    if (!email.includes("@")) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกรูปแบบอีเมลให้ถูกต้อง");
      return;
    }
    if (!phone) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทร");
      return;
    }
    if (phone.length < 10) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทรให้ครบถ้วน");
      return;
    }
    if (!float(phone)) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทรให้ถูกต้อง");
      return;
    }
    loading(true);

    await fetch(
      process.env.REACT_APP_API_URL + `/contact/${new Date().getTime()}.json`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: new Date().getTime(),
          product,
          full_name,
          email,
          phone,
          company,
          title,
          message,
        }),
      }
    );
    loading(false);
    alert(
      "#",
      "success",
      "สำเร็จ",
      "ขอบคุณที่ติดต่อเรา! เราจะติดต่อกลับโดยเร็วที่สุด"
    );
  };
  render() {
    const {
      slideIndex,

      photo_index,
      data_product,
      full_name,
      email,
      phone,
      company,
      title,
      message,
      name_contact_1,
      address_contact_1,
      phone_contact_1,
      fax_contact_1,
      email_contact_1,
      website_contact_1,
      title_section2_index,
      message_section2_index,

      title1_section2_index,
      message1_section2_index,
      title2_section2_index,
      message2_section2_index,
      title3_section2_index,
      message3_section2_index,
      photo_section3_index,

      title_section3_index,
      message_section3_index,
      photo_section4_index,
      title_section5_index,
      message_section5_index,
      photo_section5_index,
      howto_section6_index,
      customer_section7_index,
    } = this.state;
    return (
      <div className="w-100 min-vh-100 bg-light position-relative">
        <Navbar />
        {/* SECTION 1 */}
        <div
          className="w-100 text-white position-relative overflow-hidden"
          style={{ height: 600, minHeight: 600 }}
        >
          {/* Slides */}
          {photo_index?.map((item, index) => (
            <div
              key={index}
              className="hero-slide position-absolute top-0 start-0 w-100 h-100"
              style={{
                backgroundImage: `url(${
                  item.image || require("../assets/images/thumbnail.png")
                })`,
                opacity: slideIndex === index ? 1 : 0,
              }}
            />
          ))}

          {/* Gradient + Content */}
          <div
            className="position-relative h-100 d-flex align-items-center"
            style={{
              background:
                "linear-gradient(to right, rgba(0,0,0,0.8), rgba(0,0,0,0.2), rgba(0,0,0,0))",
            }}
          >
            <div className="row container mx-auto">
              <div className="col-12 col-md-8 col-xl-6">
                <h5 className="fw-bold mb-2">
                  ACI INCINERATOR
                </h5>

                {/* ✅ ข้อความตามสไลด์ */}
                <h1 className="fw-bold mb-3">
                  {photo_index?.[slideIndex]?.th || ""}
                </h1>

                <button
                  className="btn btn-light px-4"
                  onClick={() => (window.location.href = "/contact")}
                >
                  ติดต่อเรา
                </button>
              </div>
            </div>
          </div>

          {/* Controls */}
          <button className="carousel-btn left icon" onClick={this.prevSlide}>
            {"\uf104"}
          </button>
          <button className="carousel-btn right icon" onClick={this.nextSlide}>
            {"\uf105"}
          </button>

          {/* Indicators */}
          <div className="carousel-dots">
            {photo_index?.map((_, i) => (
              <span
                key={i}
                className={`dot ${i === slideIndex ? "active" : ""}`}
                onClick={() => this.goToSlide(i)}
              />
            ))}
          </div>
        </div>
        {/* SECTION 2 */}
        <div className="w-100 bg-secondary-light">
          <div className="container mx-auto p-5 text-center">
            <h5 className="fw-bold mb-3 text-primary">
              {title_section2_index}
            </h5>
            <span className="text-secondary">{message_section2_index}</span>
            <div className="row">
              {title1_section2_index && (
                <div className="col-12 col-md-8 col-lg-4 mb-3 mx-auto">
                  <div className="p-3" style={{ minHeight: 212 }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="65"
                      height="65"
                      viewBox="0 0 100 100"
                      xmlSpace="preserve"
                      className="eco-icon"
                    >
                      <g>
                        <path
                          d="m30.67 54.253 4.296 2.597c.7 0 1.099-.3 1.099-.899-.1-.6-.2-1.099-.5-1.598l-9.39-17.582-20.778.5c-.7-.1-1.399.5-1.399 1.199v.3c0 .2.3.499.9.898l4.195 2.498-4.695 7.092C3.299 50.757 2.7 52.455 2.5 54.253c.1 1.399.5 2.797 1.299 3.996l14.185 24.674c-.3-1.499-.5-2.897-.5-4.396 0-2.697.9-5.194 2.398-7.392zM36.065 39.868l11.687-18.08c-4.395-9.89-8.99-14.885-13.885-14.885-2.997 0-4.895.799-5.994 2.497L16.885 26.982z"
                          fill="#1a4275"
                        />
                        <path
                          d="M26.575 88.817H49.05V65.44H27.374a91.756 91.756 0 0 0-4.995 7.692c-1.099 1.998-1.598 4.296-1.698 6.593 0 5.994 1.898 9.09 5.894 9.09zM72.926 35.573l10.09-16.783c.299-.599.499-1.198.499-1.798 0-.799-.3-1.099-.8-1.099-.3.2-.699.3-.998.4l-4.596 1.898L72.926 10c-1.798-3.697-5.494-5.595-11.088-5.595H35.665c2.298.6 4.495 1.499 6.493 2.897 2.697 2.098 5.395 6.094 8.192 11.888l5.194 10.789-3.796 1.798c-.4.2-.6.599-.6.999 0 .599.4.999 1.2 1.098zM82.915 85.32 97.5 58.848c-1.898 2.298-4.295 3.996-6.993 4.995-2.797.8-5.794 1.099-8.69.999H65.534v-3.397c0-1.298-.3-1.997-1-1.997-.399 0-.798.2-.998.499l-10.09 17.781 10.59 16.383c.798 1.199 1.498 1.698 2.097 1.399.6-.2.9-.5.9-.9v-5.594h8.99a6.935 6.935 0 0 0 6.892-3.696z"
                          fill="#1a4275"
                        />
                        <path
                          d="M76.622 61.445h9.69c2.697-.1 5.294-1.198 7.192-3.096 2.697-2.098 3.996-4.396 3.996-6.693 0-1.199-.4-2.298-1.099-3.197L84.913 30.778 65.034 42.366z"
                          fill="#1a4275"
                        />
                      </g>
                    </svg>
                    <h5 className="fw-bold my-3 text-primary">
                      {title1_section2_index}
                    </h5>
                    <span className="text-secondary">
                      {message1_section2_index}
                    </span>
                  </div>
                </div>
              )}
              {title2_section2_index && (
                <div className="col-12 col-md-8 col-lg-4 mb-3 mx-auto">
                  <div className="p-3" style={{ minHeight: 212 }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="65"
                      height="65"
                      viewBox="0 0 512 512"
                      xmlSpace="preserve"
                    >
                      <g>
                        <path
                          d="M256 0C148.013 0 60.16 87.854 60.16 195.84S148.014 391.68 256 391.68s195.84-87.854 195.84-195.84S363.987 0 256 0zm91.899 322.328L256 278.839l-91.899 43.489 12.962-100.839-69.758-73.961 99.909-18.833L256 39.493l48.785 89.2 99.91 18.833-69.758 73.962z"
                          fill="#1a4275"
                        />
                        <path
                          d="M285.277 155.544 256 102.014l-29.277 53.53-59.958 11.302 41.864 44.386-7.779 60.516L256 245.649l55.15 26.099-7.779-60.516 41.864-44.386zM119.195 443.452a102.17 102.17 0 0 0 37.469-13.244v-31.435a224.341 224.341 0 0 1-37.469-23.214zM355.336 430.208a102.17 102.17 0 0 0 37.469 13.244v-67.893a224.407 224.407 0 0 1-37.469 23.214zM186.664 410.876V512c22.209-3.206 42.63-13.521 58.624-29.838L256 471.234l10.712 10.928c15.994 16.316 36.415 26.632 58.624 29.838V410.876C303.222 417.98 279.897 421.68 256 421.68s-47.222-3.7-69.336-10.804z"
                          fill="#1a4275"
                        />
                      </g>
                    </svg>
                    <h5 className="fw-bold my-3 text-primary">
                      {title2_section2_index}
                    </h5>
                    <span className="text-secondary">
                      {message2_section2_index}
                    </span>
                  </div>
                </div>
              )}
              {title3_section2_index && (
                <div className="col-12 col-md-8 col-lg-4 mb-3 mx-auto">
                  <div className="p-3" style={{ minHeight: 212 }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="65"
                      height="65"
                      viewBox="0 0 512 512"
                      xmlSpace="preserve"
                    >
                      <g>
                        <path
                          d="m256 143.75 56.277 29.59-10.75-62.668 45.559-44.399-62.945-9.14L256 0l-28.14 57.133-62.946 9.14 45.559 44.399-10.75 62.668zM446.137 159.129l-28.14-57.024-28.142 57.024-62.914 9.14 45.528 44.387-10.75 62.68 56.277-29.59 56.309 29.59-10.782-62.68L512 168.27zM48.477 212.656l-10.782 62.68 56.309-29.59 56.277 29.59-10.75-62.68 45.528-44.386-62.914-9.141-28.141-57.024-28.14 57.024L0 168.269zM331 286c0-41.352-33.648-75-75-75s-75 33.648-75 75 33.648 75 75 75 75-33.648 75-75zM151 466v46h210v-46c0-57.89-47.11-105-105-105s-105 47.11-105 105zM481 496c0-41.352-33.648-75-75-75-7.758 0-15.094 1.523-22.137 3.719C388.11 437.813 391 451.512 391 466v46h90z"
                          fill="#1a4275"
                        />
                        <path
                          d="M466 361c0-33.09-26.91-60-60-60s-60 26.91-60 60c0 1.91.387 3.715.563 5.578 14.792 13.485 26.722 29.942 34.386 48.766C388.598 418.887 397.031 421 406 421c33.09 0 60-26.91 60-60zM165.438 366.578c.175-1.863.562-3.668.562-5.578 0-33.09-26.91-60-60-60s-60 26.91-60 60 26.91 60 60 60c8.969 0 17.402-2.113 25.05-5.652 7.665-18.828 19.595-35.286 34.387-48.77zM31 496v16h90v-46c0-14.488 2.89-28.188 7.137-41.281C121.094 422.523 113.757 421 106 421c-41.352 0-75 33.648-75 75z"
                          fill="#1a4275"
                        />
                      </g>
                    </svg>
                    <h5 className="fw-bold my-3 text-primary">
                      {title3_section2_index}
                    </h5>
                    <span className="text-secondary">
                      {message3_section2_index}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* SECTION 3 */}
        <div className="w-100 bg-light">
          <div className="row">
            <div className="col-12 col-md-6 col-lg-6">
              <div
                className="d-none d-md-block position-relative align-content-center"
                style={{
                  minHeight: 600,
                  backgroundImage: `
                    linear-gradient(to left,
                      rgba(248,249,250,1),
                      rgba(248,249,250,0.2),
                      rgba(248,249,250,0),
                      rgba(248,249,250,0)
                    ),
                    url(${photo_section3_index || THUMBNAIL})
                  `,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              />
              <div
                className="d-block d-md-none position-relative align-content-center"
                style={{
                  minHeight: 600,
                  backgroundImage: `
                    linear-gradient(to bottom,
                      rgba(248,249,250,1),
                      rgba(248,249,250,0.2),
                      rgba(248,249,250,0),
                      rgba(248,249,250,0),
                      rgba(248,249,250,0.2),
                      rgba(248,249,250,1)
                    ),
                    url(${photo_section3_index || THUMBNAIL})
                  `,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              />
            </div>

            <div className="col-12 col-md-6 col-lg-6 text-start px-5">
              <div className="my-5 py-4">
                <h2 className="fw-bold mb-4">{title_section3_index}</h2>
                <div className="text-secondary">{message_section3_index}</div>
                <a className="btn btn-dark px-4 mt-4" href="/about">
                  อ่านเพิ่มเติม
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* SECTION 4 */}
        <div className="w-100 bg-secondary-light align-content-center">
          <div className="row container mx-auto mt-5 mb-2 justify-content-center">
            {photo_section4_index.map((item, index) => (
              <div className={"col-12 col-sm-6 col-lg-4 mb-3"}>
                <div
                  className="w-100 position-relative rounded-3 overflow-hidden mb-3 shadow-sm popup pointer px-4 px-xl-5 py-5"
                  style={{
                    backgroundImage: `
                      linear-gradient(to bottom,
                        rgba(0,0,0,1),
                        rgba(0,0,0,0.2),
                        rgba(0,0,0,0),
                        rgba(0,0,0,0)
                      ),
                      url(${item.image || THUMBNAIL})
                    `,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    height: 600,
                  }}
                >
                  <h3
                    className="fw-bold w-100 overflow-hidden mb-2 text-nowrap text-light"
                    style={{ textOverflow: "ellipsis" }}
                  >
                    {item[`${locale}`]?.title || item.th?.title || ""}
                  </h3>
                  <span
                    className="text-light"
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {item[`${locale}`]?.description ||
                      item.th?.description ||
                      ""}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* SECTION 5 */}
        <div className="w-100 bg-secondary-light align-content-center">
          <div className="container px-4 my-5 text-center">
            <h2 className="fw-bold mb-0 mx-3">
              สินค้าของเรา เอซีไอ อินซิเนอเรเทอร์
            </h2>
            <div className="text-secondary">
              เตาเผาขยะชุมชนสำเร็จรูปที่ออกแบบด้วยเทคโนโลยีญี่ปุ่น ผสานความเชี่ยวชาญของทีมงานไทย มุ่งเน้นประสิทธิภาพในการกำจัดขยะ ความปลอดภัยต่อผู้ใช้งาน และความเป็นมิตรต่อสิ่งแวดล้อม
            </div>
          </div>
          <div className="row container mx-auto mt-5 mb-2 justify-content-center">
            {data_product.map((item, index) => (
              <div
                className={
                  "col-12 col-sm-6 col-lg-4 col-xl-3 mb-3 p-1 product pointer" +
                  (index > 3 ? " d-none d-lg-block d-xl-none" : "")
                }
                onClick={() => {
                  window.location.href = "/detail-product?id=" + item.uid;
                }}
              >
                <div className="w-100 hpx-400 bg-light d-flex align-items-center justify-content-center position-relative rounded-3 overflow-hidden mb-3 shadow-sm">
                  {item.photo[0] ? (
                    <img
                      alt="LOGO"
                      src={item.photo[0]}
                      className="h-100 w-100 mx-auto my-5"
                      style={{ objectFit: "cover" }}
                      loading="lazy"
                    />
                  ) : (
                    <img
                      alt="LOGO"
                      src={THUMBNAIL}
                      className="h-100 w-75 mx-auto my-5"
                      style={{ objectFit: "contain" }}
                      loading="lazy"
                    />
                  )}
                </div>

                <h6
                  className="fw-bold w-100 overflow-hidden mb-2 text-nowrap"
                  style={{ textOverflow: "ellipsis" }}
                >
                  {item[`${locale}_product_name`] || item.th_product_name || ""}
                </h6>
                <small
                  className="text-secondary"
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {item[`${locale}_description`] || item.th_description || ""}
                </small>
                <button className="btn btn-primary px-4 mt-3">
                  รายละเอียด
                </button>
              </div>
            ))}
          </div>
          <div className="d-flex justify-content-center w-100 mt-3 mb-5">
            <button
              className="btn btn-primary px-4"
              onClick={() => {
                window.location.href = "/product";
              }}
            >
              ดูสินค้าเพิ่มเติม
            </button>
          </div>
        </div>
        {/* SECTION 6 */}
        <div className="w-100 bg-light">
          <div className="row">
            <div className="col-12 col-md-6 col-lg-6 text-start px-5">
              <div className="my-5 py-4">
                <h2 className="fw-bold mb-4">{title_section5_index}</h2>
                <div className="text-secondary">{message_section5_index}</div>
                <a className="btn btn-dark px-4 mt-4" href="/about">
                  อ่านเพิ่มเติม
                </a>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6">
              <div
                className="d-none d-md-block position-relative align-content-center"
                style={{
                  minHeight: 600,
                  backgroundImage: `
                    linear-gradient(to right,
                      rgba(248,249,250,1),
                      rgba(248,249,250,0.2),
                      rgba(248,249,250,0),
                      rgba(248,249,250,0)
                    ),
                    url(${photo_section5_index || THUMBNAIL})
                  `,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              />
              <div
                className="d-block d-md-none position-relative align-content-center"
                style={{
                  minHeight: 600,
                  backgroundImage: `
                    linear-gradient(to bottom,
                      rgba(248,249,250,1),
                      rgba(248,249,250,0.2),
                      rgba(248,249,250,0),
                      rgba(248,249,250,0),
                      rgba(248,249,250,0.2),
                      rgba(248,249,250,1)
                    ),
                    url(${photo_section5_index || THUMBNAIL})
                  `,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              />
            </div>
          </div>
        </div>
        {/* SECTION 7 */}
        <div className="w-100 bg-light align-content-center">
          <div className="container px-4 my-5 text-center">
            <h2 className="fw-bold mb-0 mx-3">
              วิธีการใช้งานของเรา - เตาเผาขยะชุมชน
            </h2>
          </div>
          <div className="container">
            <div className="row pb-5">
              {howto_section6_index?.map((item, index) => (
                <div className="col-6 col-lg-3 mb-3 p-1">
                  <div className="rounded-3 bg-secondary-light h-100 p-3">
                    <div className="d-flex align-items-center justify-content-center fw-bold wpx-50 hpx-50 rounded-circle bg-primary text-white mb-2 text-28">
                      {index + 1}
                    </div>
                    <h5 className="mt-2 fw-bold">
                      {item[`${locale}`]?.title || item.th?.title || ""}
                    </h5>
                    <span>
                      {item[`${locale}`]?.description ||
                        item.th?.description ||
                        ""}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* SECTION 8 */}
        <div className="w-100 bg-light align-content-center bg-primary">
          <div className="container px-4 py-4 my-5 text-light d-flex justify-content-between">
            <div>
              <h2 className="fw-bold">งานด้านที่ปรึกษา</h2>
              <h5>
                ในฐานผู้เชี่ยวชาญเตาเผาทุกประเภท บริษัทฯ ได้รับเป็นที่ปรึกษาให้กับบริษัทต่างๆ ในประเทศ
              </h5>
            </div>
            <div className="d-flex align-items-center">
              <button
                className="btn btn-light px-4"
                onClick={() => {
                  window.location.href = "/product";
                }}
              >
                สินค้าของเรา
              </button>
            </div>
          </div>
        </div>
        {/* SECTION 9 */}
        <div className="w-100 bg-light align-content-center">
          <div className="container px-4 my-5 text-center">
            <h2 className="fw-bold mb-0 mx-3">กลุ่มลูกค้าของเรา</h2>
            <div className="text-secondary">
              เตาเผาขยะชุมชนของ ACI Incinerator ได้รับการออกแบบเพื่อตอบโจทย์การใช้งานที่หลากหลาย เหมาะกับทั้งภาครัฐ ภาคเอกชน และชุมชน ที่ต้องการจัดการขยะอย่างมีประสิทธิภาพและเป็นมิตรต่อสิ่งแวดล้อม
            </div>
          </div>
          <div className="container">
            <div className="row pb-5 justify-content-center">
              {customer_section7_index?.map((item, index) => (
                <div className="col-6 col-md-4 col-xl-3 mb-3 p-1">
                  <div className="rounded-3 bg-secondary-light h-100 p-3">
                    <img
                      alt="LOGO"
                      src={item.image || THUMBNAIL}
                      className="hpx-200 w-100 mx-auto"
                      style={{ objectFit: "cover" }}
                      loading="lazy"
                    />
                    <h5 className="mt-2 fw-bold">
                      {item[`${locale}`]?.title || item.th?.title || ""}
                    </h5>
                    <span className="text-secondary">
                      {item[`${locale}`]?.description ||
                        item.th?.description ||
                        ""}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* SECTION 10 */}
        <div className="w-100 position-relative">
          <div className="container">
            <div className="row mx-0">
              <div className="col-12 col-md-6 mb-3">
                <div className="my-5">
                  <h3 className="fw-bold mb-2">{name_contact_1}</h3>
                  <div className="mb-4 text-secondary">
                    เรานำเสนอเตาเผาขยะคุณภาพสูง มุ่งเน้นการผลิตเตาเผาขยะที่ไม่ก่อมลพิษ “จริงใจ ห่วงใย สิ่งแวดล้อม”
                  </div>
                  {address_contact_1 && (
                    <div className="d-flex align-items-center mb-3">
                      <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                        <h5 className="icon fw-bold text-22">{"\uf015"}</h5>
                      </div>
                      <div>
                        <b>{name_contact_1}</b>
                        <br />
                        <span>{address_contact_1}</span>
                      </div>
                    </div>
                  )}
                  {phone_contact_1 && (
                    <div className="d-flex align-items-center mb-3">
                      <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                        <h5 className="icon fw-bold text-22">{"\uf095"}</h5>
                      </div>
                      <div>
                        <b>โทรได้ที่</b>
                        <br />
                        <span>
                          {phone_contact_1.split(",").map((phone, index) => (
                            <a
                              href={`tel:${phone}`}
                              key={index}
                              style={{
                                color: "inherit",
                                textDecoration: "none",
                              }}
                            >
                              {phone}
                              {index !== phone_contact_1.split(",").length - 1
                                ? ", "
                                : ""}
                            </a>
                          ))}
                        </span>
                      </div>
                    </div>
                  )}
                  {fax_contact_1 && (
                    <div className="d-flex align-items-center mb-3">
                      <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                        <h5 className="icon fw-bold text-22">{"\uf1ac"}</h5>
                      </div>
                      <div>
                        <b>โทรสาร</b>
                        <br />
                        <span>{fax_contact_1}</span>
                      </div>
                    </div>
                  )}
                  {email_contact_1 && (
                    <div className="d-flex align-items-center mb-3">
                      <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                        <h5 className="icon fw-bold text-22">{"\uf0e0"}</h5>
                      </div>
                      <div>
                        <b>อีเมล</b>
                        <br />
                        <span>
                          <a
                            href={`mailto:${email_contact_1}`}
                            style={{ color: "inherit", textDecoration: "none" }}
                          >
                            {email_contact_1}
                          </a>
                        </span>
                      </div>
                    </div>
                  )}
                  {website_contact_1 && (
                    <div className="d-flex align-items-center mb-3">
                      <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                        <h5 className="icon fw-bold text-22">{"\uf0ac"}</h5>
                      </div>
                      <div>
                        <b>เว็บไซต์</b>
                        <br />
                        <span>
                          <a
                            href={website_contact_1}
                            style={{ color: "inherit", textDecoration: "none" }}
                          >
                            {website_contact_1}
                          </a>
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12 col-md-6 py-5" id="input-message">
                <div className="card card-dashboard rounded-3 bg-secondary-light p-4 shadow-sm border-0">
                  <div className="row">
                    <div className="col-6">
                      <div className="mb-2">ชื่อ - นามสกุล</div>
                      <input
                        className="form-control mb-3"
                        type="text"
                        placeholder="ชื่อ - นามสกุล"
                        onChange={(e) => {
                          this.setState({ full_name: e.target.value });
                        }}
                        value={full_name}
                      />
                    </div>
                    <div className="col-6">
                      <div className="mb-2">เบอร์โทรศัพท์</div>
                      <input
                        className="form-control mb-3"
                        type="text"
                        placeholder="เบอร์โทรศัพท์"
                        maxLength={10}
                        onChange={(e) => {
                          if (!float(e.target.value)) {
                            return;
                          }
                          this.setState({ phone: e.target.value });
                        }}
                        value={phone}
                      />
                    </div>
                    <div className="col-6">
                      <div className="mb-2">อีเมล</div>
                      <input
                        className="form-control mb-3"
                        type="email"
                        placeholder="อีเมล"
                        onChange={(e) => {
                          this.setState({ email: e.target.value });
                        }}
                        value={email}
                      />
                    </div>
                    <div className="col-6">
                      <div className="mb-2">บริษัท</div>
                      <input
                        className="form-control mb-3"
                        type="text"
                        placeholder="บริษัท"
                        onChange={(e) => {
                          this.setState({ company: e.target.value });
                        }}
                        value={company}
                      />
                    </div>
                    <div className="col-12">
                      <div className="mb-2">หัวข้อที่สอบถาม</div>
                      <input
                        className="form-control mb-3"
                        type="text"
                        placeholder="หัวข้อที่สอบถาม"
                        onChange={(e) => {
                          this.setState({ title: e.target.value });
                        }}
                        value={title}
                      />
                    </div>
                    <div className="col-12">
                      <div className="mb-2">รายละเอียด</div>
                      <textarea
                        className="form-control mb-3"
                        rows={8}
                        placeholder="รายละเอียด"
                        onChange={(e) => {
                          this.setState({ message: e.target.value });
                        }}
                        value={message}
                      />
                    </div>
                    <div className="col-12">
                      <button
                        className="btn btn-primary px-5 w-100"
                        onClick={async () => {
                          this.Submit();
                        }}
                      >
                        ส่งข้อมูล
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="hpx-30"></div>
        <Footer />
      </div>
    );
  }
}
